// Links to firebase account admin@vidatec.com
export default {
  apiKey: "AIzaSyCpmkGmLHUcr92YzVTOZio6pgmSIm5I4zQ",
  authDomain: "engage4-uat.firebaseapp.com",
  projectId: "engage4-uat",
  storageBucket: "engage4-uat.firebasestorage.app",
  messagingSenderId: "407354837578",
  appId: "1:407354837578:web:af6f4a571afccc9eef34b3",
  measurementId: "G-TT4B4PWF78"
};
